import React from 'react';
import { ArrowRight } from 'lucide-react';
export function FeaturedWines() {
  return <section className="bg-cream py-[140px] px-8" id="wines" data-id="element-18">
      <div className="max-w-7xl mx-auto" data-id="element-19">
        {/* Header */}
        <div className="text-center mb-16 section-reveal" data-id="element-20">
          <h2 className="font-optima font-semibold text-[36px] md:text-[48px] lg:text-[64px] text-charcoal mb-6" data-id="element-21">
            OUR COLLECTION
          </h2>
          <p className="font-optima text-[20px] text-charcoal/90 max-w-[900px] mx-auto leading-[1.8]" data-id="element-22">
            Our wines are a celebration of the Pyrenees. Crafted with precision
            and care, each bottle tells a story of its vintage and its place.
            From the classic elegance of our Estate Range to the premium Single
            Block wines and the vibrant GO Series, the Glenlofty collection
            offers a wine for every palate and occasion.
          </p>
        </div>

        {/* Asymmetric Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-[1.5fr_1fr] gap-8" data-id="element-23">
          {/* Large Card - Left */}
          <div className="group bg-white rounded-[8px] overflow-hidden shadow-md hover:shadow-xl transition-all duration-500 cursor-pointer h-full flex flex-col section-reveal stagger-1" data-id="element-24">
            <div className="relative h-[400px] lg:h-[600px] overflow-hidden bg-[#f9f7f4] flex items-center justify-center" data-id="element-25">
              <img src="https://assets.modern-commerce.io/Glenlofty%20Project%20Files/SINGLE%20VINEYARD%20Ridge%20Shiraz.png" alt="Ridge Block Shiraz" className="h-[85%] w-auto object-contain transition-transform duration-700 group-hover:scale-105 rotate-90" data-id="element-26" />
            </div>
            <div className="p-8 flex-1 flex flex-col justify-center" data-id="element-27">
              <span className="font-optima font-light text-[12px] uppercase text-gold tracking-[0.15em]" data-id="element-28">
                Single Block
              </span>
              <h3 className="font-optima font-semibold text-[24px] md:text-[32px] text-charcoal mt-2" data-id="element-29">
                Ridge Block Shiraz
              </h3>
              <p className="font-optima text-[16px] text-charcoal/80 mt-3" data-id="element-30">
                Premium single-block wines of exceptional quality, showcasing
                the unique terroir of our highest elevation vineyards.
              </p>
              <div className="mt-6 flex items-center text-gold font-semibold text-sm uppercase tracking-wider opacity-0 group-hover:opacity-100 transition-opacity transform translate-y-2 group-hover:translate-y-0" data-id="element-31">
                Explore Wine <ArrowRight size={16} className="ml-2" data-id="element-32" />
              </div>
            </div>
          </div>

          {/* Right Column - Stacked Cards */}
          <div className="flex flex-col gap-8" data-id="element-33">
            {/* Card 2 */}
            <div className="group bg-white rounded-[8px] overflow-hidden shadow-md hover:shadow-xl transition-all duration-500 cursor-pointer section-reveal stagger-2" data-id="element-34">
              <div className="relative h-[250px] overflow-hidden bg-[#f9f7f4] flex items-center justify-center" data-id="element-35">
                <img src="https://assets.modern-commerce.io/Glenlofty%20Project%20Files/ESTATE%20Cabernet%20Sauvignon.png" alt="Estate Shiraz" className="h-[90%] w-auto object-contain transition-transform duration-700 group-hover:scale-105 rotate-90" data-id="element-36" />
              </div>
              <div className="p-6" data-id="element-37">
                <span className="font-optima font-light text-[12px] uppercase text-gold tracking-[0.15em]" data-id="element-38">
                  Estate Reserve
                </span>
                <h3 className="font-optima font-semibold text-[24px] text-charcoal mt-2" data-id="element-39">
                  Estate Shiraz
                </h3>
                <p className="font-optima text-[16px] text-charcoal/80 mt-2" data-id="element-40">
                  Classic expressions of our estate vineyard.
                </p>
              </div>
            </div>

            {/* Card 3 */}
            <div className="group bg-white rounded-[8px] overflow-hidden shadow-md hover:shadow-xl transition-all duration-500 cursor-pointer section-reveal stagger-3" data-id="element-41">
              <div className="relative h-[250px] overflow-hidden bg-[#f9f7f4] flex items-center justify-center" data-id="element-42">
                <img src="https://assets.modern-commerce.io/Glenlofty%20Project%20Files/GO%20Chardonnay.png" alt="GO Chardonnay" className="h-[90%] w-auto object-contain transition-transform duration-700 group-hover:scale-105 rotate-90" data-id="element-43" />
              </div>
              <div className="p-6" data-id="element-44">
                <span className="font-optima font-light text-[12px] uppercase text-gold tracking-[0.15em]" data-id="element-45">
                  GO Range
                </span>
                <h3 className="font-optima font-semibold text-[24px] text-charcoal mt-2" data-id="element-46">
                  GO Chardonnay
                </h3>
                <p className="font-optima text-[16px] text-charcoal/80 mt-2" data-id="element-47">
                  Vibrant, youthful wines for immediate enjoyment.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* View All Button */}
        <div className="text-center mt-16 section-reveal" data-id="element-48">
          <button className="border-2 border-charcoal text-charcoal bg-transparent hover:bg-charcoal hover:text-white px-10 py-4 rounded-[4px] uppercase text-[16px] font-semibold tracking-wide-btn transition-all" data-id="element-49">
            View All Wines
          </button>
        </div>
      </div>
    </section>;
}